/**
 * IMPORTS
 */

const handleFormatTypeDelivery = (tipo: string) => {
  const nomes = {
    balcao: "Balcão",
    correios: "Correios",
    motoboy_letscom: "Motoboy Letscom",
    transportadora: "Transportadora",
    outros: "Outros",
  };
  return nomes[tipo as keyof typeof nomes] || tipo;
};

export { handleFormatTypeDelivery };
